<template>
    <BaseAlert :type="Functional.Error">
        {{ $t('globalMessages.serverError.message') }}
        <template #description>
            {{ $t('globalMessages.serverError.description') }}
        </template>
    </BaseAlert>
</template>

<script setup lang="ts">
import { Functional } from '@/types';
import BaseAlert from './BaseAlert.vue';
</script>
